import { ButtonLink, IconBadge } from '@coop/components';
import { UserIcon } from '@coop/icons';
import { useEffect } from 'react';

import { appConfig } from '../../../../appConfig';
import A11yTextWrapper from '../../../common/components/A11yTextWrapper/A11yTextWrapper';
import { useAppDispatch, useAppSelector } from '../../../common/hooks/useThunkDispatch';
import { useHybrisMunicipalUserInfo } from '../../../common/hooks/useUserQueries';
import { cartSelectors } from '../../../common/selectors/cartSelectors';
import { cartThunks } from '../../../common/thunks/cartThunks';
import styles from './MunicipalNotice.module.scss';

const MunicipalNotice = () => {
    const dispatch = useAppDispatch();

    const commentAboutCustomer = useAppSelector(cartSelectors.selectCommentAboutCustomer);
    const isCartReady = useAppSelector(cartSelectors.isCartReady);

    useEffect(() => {
        if (!isCartReady) {
            dispatch(cartThunks.getCart());
        }
    }, [isCartReady, dispatch]);

    const { data: municipalUserInfo } = useHybrisMunicipalUserInfo();

    if (!municipalUserInfo) {
        return null;
    }

    const userName = `${municipalUserInfo.firstName} ${municipalUserInfo.lastName}`;

    return (
        <div className={styles.NoticeContainer}>
            <div className={styles.Notice}>
                <div className={styles.User}>
                    <div className={styles.UserCard}>
                        <IconBadge theme="white" size="medium" icon={<UserIcon />} />
                        <A11yTextWrapper
                            className={styles.Text}
                            a11yType="visuallyHiddenText"
                            a11yText={`Du handlar åt ${userName}`}
                        >
                            <span aria-hidden>Du handlar åt</span>
                            <span aria-hidden className={styles.Name}>
                                {userName}
                            </span>
                        </A11yTextWrapper>
                    </div>
                    {commentAboutCustomer && (
                        <span className={styles.Comment}>
                            {`Kommentar: ${commentAboutCustomer}`}
                        </span>
                    )}
                </div>
                <div className={styles.Button}>
                    <ButtonLink
                        theme="subtle"
                        href={appConfig.coopSettings.logoutUrl}
                        aria-label={`Avbryt handling åt ${userName}`}
                    >
                        Avbryt
                    </ButtonLink>
                </div>
            </div>
        </div>
    );
};

export default MunicipalNotice;
